import _flatMap from 'lodash/flatMap';
import _reduce from 'lodash/reduce';
import _difference from 'lodash/difference';
import _uniq from 'lodash/uniq';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';

export const pickErrorDiff = (request, response) => {
  return _difference(request, response);
};

export const pickPromoSkus = (productData, skusInDesign) => {

  const promoItemIds = _reduce(skusInDesign, (prev, curr) => {
    const conditionalPromotions = productData?.[curr]?.pricing?.conditionalPromotions;

    if (!conditionalPromotions) {
      return [...prev];
    }

    const eligibilityCriteria = conditionalPromotions?.[0]?.eligibilityCriteria;

    if (eligibilityCriteria) {
      const allOmsSkus = _flatMap(eligibilityCriteria, (criteria) => criteria.omsSkus);
      return [...prev, ...allOmsSkus];
    }

    return [...prev];
  }, []);

  const diff = _difference(_uniq(promoItemIds), Object.keys(productData));

  if (_isEmpty(diff)) {
    return null;
  }

  return diff;
};

export const addPricingAndFulfillment = (productData, pricingAndFulfillmentData) => _map(productData, (item) => ({
  ...item,
  fulfillment: pricingAndFulfillmentData?.[item?.itemId]?.fulfillment || { fulfillmentOptions: null },
  pricing: pricingAndFulfillmentData?.[item?.itemId]?.pricing || { pricingOptions: null }
}));
